import styled from 'styled-components/macro';

export const PCMenu = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  position: fixed;
  left: 0;
  top: 64px;
  width: 300px;
  max-width: var(--body-offset-left);
  background-color: inherit;
  z-index: 2;
`;

export const MobileMenu = styled.div<{ isTablet: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(props) => (props.isTablet ? '8px 32px' : '8px 16px')};
  gap: 8px;
`;

export const PCItem = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  gap: 8px;
  border-radius: 6px;
  background-color: ${(props) =>
    props.isSelected ? props.theme.colors.primary[50] : 'inherit'};
  transition-duration: ${(props) => props.theme.tokens.animation.duration.base};

  &:hover {
    background-color: ${(props) =>
      props.isSelected
        ? props.theme.colors.primary[100]
        : props.theme.colors.primary[50]};
  }
`;
